// WEB (internet-initiated) ACH debit authorization shown in the DepositModal. The EXACT text the
// customer sees is sent back to the backend verbatim (NACHA proof-of-authorization) tagged with the
// version below, so display text and stored text always match.
export const DEPOSIT_CONSENT_VERSION = 'deposit-web-auth-v1-draft';

export const buildDepositConsentText = (params: {
  amountFormatted: string; // e.g. "$250.00"
  bankName: string;
  bankMask?: string | null;
}): string => {
  const account = params.bankMask
    ? `my ${params.bankName} account ending in ${params.bankMask}`
    : `my ${params.bankName} account`;
  return (
    `I authorize TACH to initiate a one-time ACH debit of ${params.amountFormatted} from ${account} ` +
    `and credit my TACH account with those funds. I also authorize TACH to initiate an ACH credit to the same account, if needed, to correct an ` +
    `erroneous debit. This authorization applies only to this transaction and remains in effect until the ` +
    `transaction is completed. I understand that I may revoke this authorization by contacting support@tachusa.com before the ` +
    `debit has been processed.`
  );
};
